import React from 'react';

const EventsPage = () => {
  return (
    <div>
      <h1>Events Page</h1>
    </div>
  );
};

export default EventsPage;